module.exports = __webpack_public_path__ + "static/media/projectFirst.55f044ac.png";